import get from 'lodash/get';

export default function selector(storeState) {
    const audienceSegments = get(storeState, 'highIntentDashboard.audienceSegments');
    const totalSegmentCount = get(storeState, 'highIntentDashboard.totalSegmentCount');
    const isLoading = get(storeState, 'highIntentDashboard.isLoading');
    const organizationId = get(storeState, 'profile.organizationId');

    return {
        audienceSegments,
        totalSegmentCount,
        isLoading,
        organizationId,
    };
}
